import { LitElement, html, css } from 'lit';
import { phoenixCustomElement } from '../../../lib/dependencies.js';

export default class PhoenixMembershipSignupPlan extends LitElement {
    static properties = {
        config: {
            type: Object,
        },
        sendProductClickToDL: {
            type: Function,
        },
    };

    constructor() {
        super();
        this.config = {};
    }

    render() {
        return html`<input
                class="payment-plan"
                name="planCode"
                value=${this?.config?.code}
                id=${this?.config?.code}
                type="radio"
                required="true"
                .checked=${this.config?.isSelected}
                @change=${this._handleChange}
            />
            <label for=${this?.config?.code}>
                <div class="plan-wrapper ${this?.config?.code}">
                    ${this._renderBanner()} ${this._renderInterval()}
                    ${this._renderPlanAmount({ plan: this?.config, interval: 'monthly' })}
                    ${this._renderMarketingPoints()}
                    ${this._renderPlanAmount({ plan: this?.config, button: true })}
                </div>
            </label>`;
    }

    _renderInterval() {
        return html`<div class="interval">
            ${this._planIntervalLabel(this?.config?.intervalUnit, this?.config?.intervalLength)}
        </div>`;
    }

    _renderBanner() {
        const banner = this?.config?.marketingCopy?.banner;
        return banner
            ? html`<div class="banner">
                  <div class="text">${this._renderSplit(banner, 8)}</div>
              </div>`
            : html`<div class="no-banner" />`;
    }

    _renderSplit(str, len) {
        const i = str.slice(0, len + 1).lastIndexOf(' ');
        const splittingOnIndex = i > 0 ? i : 0;
        return html`<div class="split">
            ${str.slice(0, splittingOnIndex)}
            <span>${str.slice(splittingOnIndex)}</span>
        </div>`;
    }

    _renderPlanAmount({ plan, interval, button }) {
        let { intervalLength: intervalLengthInMonths } = plan;
        if (plan.intervalUnit === 'years') {
            intervalLengthInMonths = plan.intervalLength * 12;
        }

        if (!interval) {
            if (intervalLengthInMonths < 3) {
                interval = 'monthly';
            } else if (intervalLengthInMonths < 12) {
                interval = 'quarterly';
            } else if (intervalLengthInMonths === 24) {
                interval = 'biannual';
            } else {
                interval = 'annual';
            }
        }

        const amountPerMonth = plan.unitAmount / intervalLengthInMonths;
        let scale = 1;
        let label;
        if (interval === 'monthly') {
            label = ' /mo';
        } else if (interval === 'quarterly') {
            label = ' /qtr';
            scale = 3;
        } else if (interval === 'annual') {
            label = ' /yr';
            scale = 12;
        } else if (interval === 'biannual') {
            label = ' /2yr';
            scale = 24;
        }

        const className = `plan-amount${button ? '-button' : ''}`;
        return html`<div class=${className}>
            <span class="amount">$${(scale * amountPerMonth).toFixed(2)}</span>
            <span class="label">${label}</span>
        </div>`;
    }

    _renderMarketingPoints() {
        const { advantage, billing, description } = this?.config?.marketingCopy || {};
        return html`<div class="marketing-points">
            <div class="advantage">${advantage}</div>
            <div class="billing">${billing}</div>
        </div>`;
    }

    _planIntervalLabel(unit, length) {
        if (unit === 'months') {
            if (length === 1) {
                return 'Monthly';
            }
            if (length === 12) {
                return 'Annual';
            }
            if (length === 24) {
                return 'Two Year';
            }
        }
        return `${length} ${length === 1 ? unit.slice(0, -1) : unit}`;
    }

    _handleChange(event) {
        if (event.target?.checked) {
            this?.sendProductClickToDL(this?.config, this?.config.position);
        }
    }

    createRenderRoot() {
        return this;
    }
}

phoenixCustomElement('phoenix-membership-signup-plan', PhoenixMembershipSignupPlan);
